import React, { Component } from "react";
import { Link } from "react-router-dom";

/**
 * Header Navbar Component
 * Holds menus and placed after BrandNavBar component
 */

class DemoHeader extends Component {
  render() {
    return (
      <nav className="navbar col-md-10 col-lg-10 col-xl-10 tabText navHeight tabText mainNavBarbuiltBorder">
        <div className="moveRight paddingTop10 textColor">
          <Link to="/login">
            <p style={{ cursor: "pointer", color: "white" }}>Back to Login </p>
          </Link>
        </div>
      </nav>
    );
  }
}

export default DemoHeader;
